import React from 'react';

const BAR_COUNT = 7;
const BAR_COLORS = ['#3B82F6', '#6366F1', '#8B5CF6', '#A855F7', '#F59E0B', '#F97316', '#3B82F6'];

function VoiceWaves({ active = false }) {
  return (
    <div className="flex items-center justify-center gap-1.5 h-24">
      {Array.from({ length: BAR_COUNT }).map((_, i) => (
        <svg
          key={i}
          className="w-3"
          viewBox="0 0 12 80"
          preserveAspectRatio="none"
        >
          <defs>
            <linearGradient id={`wave-grad-${i}`} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={BAR_COLORS[i % BAR_COLORS.length]} stopOpacity={0.9} />
              <stop offset="100%" stopColor={BAR_COLORS[(i + 2) % BAR_COLORS.length]} stopOpacity={0.4} />
            </linearGradient>
          </defs>
          <rect
            x="0"
            y={active ? `${20 + Math.sin(Date.now() * 0.003 + i * 0.8) * 5}` : '35'}
            width="12"
            height={active ? `${40 + Math.sin(Date.now() * 0.002 + i * 0.6) * 15}` : '10'}
            rx="6"
            fill={`url(#wave-grad-${i})`}
            className={active ? 'animate-wave-bar' : ''}
            style={{
              animationDelay: `${i * 0.12}s`,
              animationDuration: `${0.8 + Math.random() * 0.6}s`,
              opacity: active ? 1 : 0.15,
            }}
          />
        </svg>
      ))}
    </div>
  );
}

export default VoiceWaves;
